import { c as _c } from "react/compiler-runtime";
import Container from "@components/Container";
import MinimalFooter from "@components/MinimalFooter";
import MinimalHeader from "@components/MinimalHeader";
import { Check } from "@icon-park/svg";
import { Icon, Title } from "@justhome/react-ui";
import { useApplicationTranslation } from "@lib/hooks/translations";
import Image from "next/image";
import { FC } from "react";
import { DefaultValues } from "react-hook-form";
import DynamicForm, { FieldValues } from "../DynamicForm";
import { FormStepComponent } from "../FormSteps/FormSteps";
interface ListItemProps {
  name: string;
  value: string;
}
const ListItem: FC<ListItemProps> = t0 => {
  const $ = _c(6);
  const {
    name,
    value
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="flex items-center text-primary-800 h-m"><Icon icon={Check} size="18" /></span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== value) {
    t2 = <span className="font-medium">{value}</span>;
    $[1] = value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== name || $[4] !== t2) {
    t3 = <li className="flex gap-2xs text-body-1">{t1}<span>{name}{t2}</span></li>;
    $[3] = name;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
const ZeroStep = t0 => {
  const $ = _c(51);
  const {
    onNext,
    step,
    value
  } = t0;
  const {
    t
  } = useApplicationTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <MinimalHeader />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== step.config.title) {
    t2 = <Title className="text-d3 mb-3s m:mb-3m">{step.config.title}</Title>;
    $[1] = step.config.title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = value as DefaultValues<T>;
  let t4;
  if ($[3] !== onNext) {
    t4 = values => onNext(values);
    $[3] = onNext;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== step.config || $[6] !== t3 || $[7] !== t4) {
    t5 = <DynamicForm defaultValues={t3} formDefinition={step.config} onSubmit={t4} />;
    $[5] = step.config;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t) {
    t6 = t("zero_step_card_title");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t6) {
    t7 = <Title className="text-h2 mb-3s m:mb-m">{t6}</Title>;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("zero_step_card_li_1");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t) {
    t9 = t("zero_step_card_li_1_bold");
    $[15] = t;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8 || $[18] !== t9) {
    t10 = <ListItem name={t8} value={t9} />;
    $[17] = t8;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t) {
    t11 = t("zero_step_card_li_2");
    $[20] = t;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t) {
    t12 = t("zero_step_card_li_2_bold");
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = <ListItem name={t11} value={t12} />;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t) {
    t14 = t("zero_step_card_li_3");
    $[27] = t;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t) {
    t15 = t("zero_step_card_li_3_bold");
    $[29] = t;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14 || $[32] !== t15) {
    t16 = <ListItem name={t14} value={t15} />;
    $[31] = t14;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== t10 || $[35] !== t13 || $[36] !== t16) {
    t17 = <ul className="space-y-3xs m:space-y-2s">{t10}{t13}{t16}</ul>;
    $[34] = t10;
    $[35] = t13;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t17 || $[39] !== t7) {
    t18 = <div className="flex-1">{t7}{t17}</div>;
    $[38] = t17;
    $[39] = t7;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="flex-none hidden m:block"><Image src="/assets/img/checklist.png" width="200" height="200" alt="" /></div>;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[42] !== t18) {
    t20 = <div className="mt-m m:mt-3xl bg-primary-25 border border-primary-800 py-s px-2s m:p-m flex gap rounded-m items-center">{t18}{t19}</div>;
    $[42] = t18;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  let t21;
  if ($[44] !== t2 || $[45] !== t20 || $[46] !== t5) {
    t21 = <Container padding={true} className="grow grid grid-cols-12 place-content-center"><div className="col-span-12 m:col-span-8 m:col-start-3 my-m">{t2}{t5}{t20}</div></Container>;
    $[44] = t2;
    $[45] = t20;
    $[46] = t5;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <MinimalFooter isFullWidth={true} />;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t21) {
    t23 = <div className="flex flex-col min-h-screen">{t1}{t21}{t22}</div>;
    $[49] = t21;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  return t23;
};
export default ZeroStep;